import { Stack, Typography } from '@mui/material'
import { FC } from 'react'

import EmailVerification from './EmailVerification'
import Title from './Title'

const SignUpFormEmailVerification: FC = () => (
  <Stack>
    <Title mb={6}>Sign up</Title>
    <Typography component="div" mb={4}>
      Verify your email address to create an account
    </Typography>
    <EmailVerification formName="sign_up" />
  </Stack>
)

export default SignUpFormEmailVerification
